var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.43195 21V20.1L14.274 8.094H15.732L20.556 20.1V21H9.43195ZM11.286 19.542H18.684L15.678 11.694C15.642 11.598 15.576 11.424 15.48 11.172C15.384 10.92 15.288 10.662 15.192 10.398C15.108 10.122 15.042 9.912 14.994 9.768C14.934 10.008 14.862 10.254 14.778 10.506C14.706 10.746 14.628 10.968 14.544 11.172C14.472 11.376 14.412 11.55 14.364 11.694L11.286 19.542Z",
  fill: "#FF6F6F"
});

function SvgIconDelta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelta);
export default __webpack_public_path__ + "static/media/Icon_Delta.b34862fcdeaa5eef119ddc310dd7af64.svg";
export { ForwardRef as ReactComponent };